import { TASKDETAIL_MODAL_TOGGLE } from "./actions.types";

export const taskDetailModalToggle = (data) => ({
    type: TASKDETAIL_MODAL_TOGGLE,
    payload: data,
})